import React from 'react';
import { TextFieldProps } from './types';

const TextField: React.FC<TextFieldProps> = ({
  id,
  label,
  value,
  onChange,
  disabled = false,
  required = false,
  placeholder = ' ',
  onFocus,
  onBlur,
  hasValue,
  getFloatingLabelStyle,
  getFloatingInputStyle,
  styles,
}) => {
  return (
    <div style={styles.floatingFieldContainer}>
      <input
        id={id}
        type="text"
        value={value || ''}
        onChange={onChange ? e => onChange(e.target.value) : undefined}
        disabled={disabled}
        onFocus={onFocus}
        onBlur={onBlur}
        style={getFloatingInputStyle(false, id)}
        placeholder={placeholder}
      />
      <label htmlFor={id} style={getFloatingLabelStyle(id, hasValue)}>
        {label}
        {required && <span style={{ color: 'red' }}>*</span>}
      </label>
    </div>
  );
};

export default React.memo(TextField);
